var React = require('react');

function Filter (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 2.75H16V1.25H0V2.75Z","fill":"#181818","key":0}),React.createElement("path",{"d":"M14 6.75H2V5.25H14V6.75Z","fill":"#181818","key":1}),React.createElement("path",{"d":"M4 10.75H12V9.25H4V10.75Z","fill":"#181818","key":2}),React.createElement("path",{"d":"M6 14.75H10V13.25H6V14.75Z","fill":"#181818","key":3})]);
}

Filter.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Filter;

Filter.default = Filter;
